import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';
import moment from 'moment';

import {
  GET_HISTORICS_REPORT_CSV,
  GET_HISTORICS_REPORT_PAGINATED,
  RESET_HISTORICS_REPORT,
  SET_HISTORICS_REPORT_FILTERS,
  SET_HISTORICS_REPORT_PAGINATION,
} from 'reports/constants';

import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

export const initialState = {
  filters: {
    fulltext: '',
    accounts: '',
    employees: '',
    costCenters: '',
    status: '',
    depreciationType: 'fiscal',
    endDate: moment().toISOString(),
    columnSearch: [
      'asset.indexInteger.indexString',
      'asset.number',
      'asset.name',
      'asset.description',
      'asset._account.name',
      'asset._account.lastname',
      'asset._subaccount.name',
      'asset._costCenter.name',
      'asset._employee.name',
      'asset._employee.lastname',
      'asset._provider.name',
      'campo', // campo del cambio solicitado
      'valor', // valor del cambio solicitado
      'changes.number',
      'changes.name',
      'changes.lastname',
      'changes.description',
      'changes._account.name',
      'changes._subaccount.name',
      'changes._costCenter.name',
      'changes._employee.name',
      'changes._employee.lastname',
      'changes._provider.name',
    ],
  },
  pagination: {
    page: 1,
    limit: 25,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  needFetch: false,
  isLoading: false,
  entities: { assets: {} },
  result: { assets: [] },
};

export const getPending = (state) => ({
  ...state,
  isLoading: true,
  needFetch: false,
});
const asset = new schema.Entity('assets');

export const getRejected = (state) => ({ ...state, isLoading: false });

//TODO: Agregar page para paginacion
export const getFulfilled = (state, { payload }) => {
  const pagination = {
    ...state.pagination,
    limit: payload.limit,
    //page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  };

  const normalized = normalize({ assets: payload.records }, { assets: [asset] });

  return { ...state, isLoading: false, pagination, ...normalized };
};

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const getCSVPending = (state) => ({ ...state, isLoading: true });
export const getCSVFulfilled = (state) => ({ ...state, isLoading: false });
export const getCSVRejected = (state) => ({ ...state, isLoading: false });

const historicsReportReducers = {
  [GET_HISTORICS_REPORT_CSV]: {
    [PENDING]: getCSVPending,
    [FULFILLED]: getCSVFulfilled,
    [REJECTED]: getCSVRejected,
  },
  [GET_HISTORICS_REPORT_PAGINATED]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_HISTORICS_REPORT_PAGINATION]: setPagination,
  [SET_HISTORICS_REPORT_FILTERS]: setFilters,
  [RESET_HISTORICS_REPORT]: reset,
};

export default TypeToReducer(historicsReportReducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/reducers/historics_report_reducers.js